import { Routes, RouterModule } from '@angular/router';
import { UserPermissionComponent } from './userpermission.component';

const routes: Routes = [
    {
        path: '',
        component: UserPermissionComponent
    },
];

export const UserPermissionRoutes = RouterModule.forChild(routes);
